<template lang="html">
  <div class="">
  </div>
</template>

<script>
export default {
  created(){
    var self = this;
    axios.get('doctor-logout')
    .then(function(response){
        self.$bus.$emit('doctorLoggedIn', true);
        localStorage.removeItem('doctorLoggedIn');
        self.$bus.$emit('sideBar', true)
        localStorage.removeItem('petName');
        self.$router.push({ name: 'home', params: { lang: window.lang } })

      })
    .catch(err => console.error(err))
 }
}

</script>

<style lang="css">
</style>
